<template lang="pug">
  #mental-wellness-aricles
    .companion-action-menu
        CompanionActionsMenu(:backButton="goBack")
    div(v-for="(article, index) in articles" :key="index")
        .mental-wellness-content
          PreviewCard(
          :moduleType="'article'" 
          :moduleIcon="'companion/article_icon'" 
          :id="article.Id" :redirectTo="{ name: 'CompanionArticle' , params:{ articleId: article.Id}}" 
          :backgroundColor="'#' + article.BackgroundColor" 
          :previewImage="article.HeroImage" 
          :duration="article.Duration" 
          :title="article.Title" 
          :tag="article.Tag" 
          :subTitle="article.PreviewText"
          )
            
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import PreviewCard from "@@/Companion/PreviewCard";
import { mapActions } from "vuex";

export default {
  name: "ArticleViewAll",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    PreviewCard,
    CompanionActionsMenu
  },
  props: {
    articles: { type: Array, required: true }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions(["snackBar"]),
    goBack() {
      window.history.back();
    }
  }
};
</script>
<style scoped>
#mental-wellness-aricles {
  width: 100% !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column !important;
  gap: 24px !important;
}
.articles-container {
  display: flex;
  width: 700px;
  align-items: flex-start;
  gap: 8px !important;
}
</style>
